import React, { useEffect } from "react";
import { useHistory } from "react-router-dom/";
import { disconnect } from "../../services/socketService";
import { useAuth } from "../../AuthContext";

export default function Logout(props) {
  const { logoutUser, clearModule } = useAuth();
  const history = useHistory();

  useEffect(() => {
    clearModule();
    logoutUser();
    disconnect();
    history.push("/login");
  }, []);

  return <div></div>;
}
